if (!customElements.get('inspired-media-gallery')) {
  customElements.define('inspired-media-gallery', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.videos = [...this.querySelectorAll('video')];
      const track = this.querySelector('.im-track');
      const hydrate = video => {
        if (video.dataset.ready) return;
        video.dataset.ready = 'true';
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
        video.load();
      };
      this.videos.forEach(video => {
        const button = video.parentElement.querySelector('.im-play');
        const update = () => {
          const paused = video.paused;
          button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
          button.querySelector('path').setAttribute('d', paused ? 'M5 3l8 5-8 5z' : 'M4 3h3v10H4zM9 3h3v10H9z');
        };
        button.addEventListener('click', () => {
          if (video.paused) {
            hydrate(video);
            video.play().catch(update);
          } else {
            video.pause();
          }
        }, options);
        update();
        video.addEventListener('play', () => { this.videos.forEach(other => { if (other !== video && !other.hasAttribute('data-autoplay')) other.pause(); }); update(); }, options);
        video.addEventListener('pause', update, options);
        video.addEventListener('ended', update, options);
      });
      this.preloadObserver = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) { hydrate(target); this.preloadObserver.unobserve(target); }
      }), { rootMargin: '200px' });
      this.videos.forEach(video => this.preloadObserver.observe(video));
      this.observer = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting) target.pause();
        else if (target.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches && !document.hidden) { hydrate(target); target.play().catch(() => {}); }
      }), { threshold: .5 });
      this.videos.forEach(video => this.observer.observe(video));
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.videos.forEach(video => video.pause()); }, options);
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const card = track.querySelector('.im-card');
        if (card) track.scrollBy({ left: (event.key === 'ArrowLeft' ? -1 : 1) * (card.clientWidth + (parseFloat(getComputedStyle(track).gap) || 0)), behavior: 'smooth' });
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.im-card');
        if (card && track.contains(card)) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.preloadObserver?.disconnect(); this.videos?.forEach(video => video.pause()); }
  });
}
